import axios from 'axios';

export function getTimeSeries(groups, period, count = 20) {
    return axios({
        method: 'GET',
        url: `/vessel-updater/stats?groups=${groups.join(",")}&period=${period}&count=${count}`
    })
    .then(response => response.data)
    .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/statistics/vessel-updater.js